module.exports = __webpack_public_path__ + "img/335168e.png";